import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, {useState, useEffect} from "react";
import storage from "../../Services/Storage";
import { createAPIEndpointSalesDiscountAllocation, EndpointSalesDiscountAllocation } from "../../Services/SalesDiscountAllocation/SalesDiscountAllocationService";
import { useNavigate } from "react-router-dom";
import Loader from "../../Components/Loader";
import * as Fa from "react-icons/fa";
import { toast } from "react-toastify";

const SalesDiscountAllocationAllRecords = () => {

    const auth = storage.getLocal("user");
    const nav = useNavigate();
    const [allRecords, setAllRecords] = useState();
    const [isLoading, setIsLoading] = useState(false);


    const getAllRecords = async () => {
        setIsLoading(true);
        try {
            const response = await createAPIEndpointSalesDiscountAllocation().get(`${EndpointSalesDiscountAllocation.GetAllSalesDiscountAllocationData}?UserId=${auth.UserId}&CompId=${auth.CompId}`);
            setAllRecords(response.data);
        }
        catch (err) {
            console.log("error SalesDiscountAllocation ", err);

        }finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getAllRecords();
    
    }, []);

    const deleteHeaderData = async (data) => {
        setIsLoading(true);
        try {
            const res = await createAPIEndpointSalesDiscountAllocation().post(`${EndpointSalesDiscountAllocation.DeleteHeaderData}?PLNo=${data.MASK_PRICE_LIST_ID}&DiscountId=${data.MASK_DISCOUNT_ID}&UserId=${auth.UserId}&CompId=${auth.CompId}`);
            if(res.data.IsSaved==true){
                getAllRecords();
                toast.success("Record deleted successfully", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }
        } catch (err) {
            console.log("Error ", err);
        } finally {
            setIsLoading(false);
        }
    };

    const add = () => {
        nav(`/masters/salesdiscountallocation/details?PRICE_LIST_ID=${""}&DISCOUNT_ID=${""}&Type=${"New"}`);

    };
    
    const handleViewEdit = (rowData) => {
        nav(`/masters/salesdiscountallocation/details?PRICE_LIST_ID=${rowData.MASK_PRICE_LIST_ID}&DISCOUNT_ID=${rowData.MASK_DISCOUNT_ID}&Type=${"View"}`, { state: rowData });

    };




    return (
        <>
            {

                isLoading ? <Loader /> :
                    <>
                        <div className="col-12 pt-0 pb-4">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <h3 className='py-2'>Sales Discount Allocation</h3>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="float-end mb-2">
                                        <button type="button" className="btn btn-primary" onClick={add}>
                                            Add New
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <section className="">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="DataTable">
                                        <DataTable
                                            value={allRecords}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50]}
                                            scrollHeight="80vh"
                                            // showGridlines
                                            filterDisplay="row"
                                            scrollable
                                            stripedRows
                                            emptyMessage="No Record found"
                                        >
                                            <Column field="PRICE_LIST_NO" header="Price List Number" filter filterMatchMode="contains" filterPlaceholder="Search here..."></Column>
                                            <Column field="DISCOUNT_NAME" header="Discount Name" filter filterMatchMode="contains" filterPlaceholder="Search here..."></Column>
                                            <Column header="Action " body={(rowData) => (
                                                <>
                                                    <img
                                                        alt="View/Edit"
                                                        width="20px"
                                                        src={require("../../Assets/Images/ViewEdit.png")}
                                                        onClick={() => handleViewEdit(rowData)}
                                                        style={{ cursor: "pointer", marginRight: "30px" }}
                                                    />

                                                    {/* <button
                                                        type="button"
                                                        className="btn btn-cancel-red me-3"
                                                        onClick={() => {
                                                            deleteHeaderData(rowData);
                                                        }}
                                                    >
                                                        Delete
                                                    </button> */}
                                                    <button className="grid-icon" onClick={()=>{
                                                        deleteHeaderData(rowData);
                                                    }}>
                                                        <Fa.FaTimes
                                                            className="cancel"
                                                           
                                                          
                                                        />
                                                    </button>
                                                </>
                                            )}>

                                            </Column>
                                            {/* There sholud be a "View/Edit" icon and "Delete" icon */}
                                        </DataTable>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </>
            }
        </>
    );
};

export default SalesDiscountAllocationAllRecords;